'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxPagan = require('redux-pagan');
var _lodash = require('lodash');
var _ramda = require('ramda');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reactIntlTelInput = require('react-intl-tel-input');var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reduxForm = require('redux-form');

var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _userAuthentication = require('../../redux/modules/userAuthentication');
var _constants = require('../../constants');
var _components = require('../../components');

var _EditUserStaff = require('./EditUserStaff.scss');var styles = _interopRequireWildcard(_EditUserStaff);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var selector = (0, _reduxForm.formValueSelector)('editUserStaff');var

EditUserStaff = function (_Component) {_inherits(EditUserStaff, _Component);function EditUserStaff() {var _temp, _this, _ret;_classCallCheck(this, EditUserStaff);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      phoneNumberIsInvalid: false,
      countryData: '' + _constants.israelCode }, _this.


    onSelectFlag = function (_, countryData) {
      _this.setState({ countryData: countryData.dialCode });
    }, _this.

    validatePhoneNumber = function () {var phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var number = phoneNumber.toString().replace(/\D/g, '');
      var isValid = !!number && number.length >= 9 && number.length <= 15;

      _this.setState({ phoneNumberIsInvalid: !isValid });
      return !isValid;
    }, _this.

    formSubmitHandler = function (_ref) {var phone = _ref.phone,description = _ref.description;var
      userToken = _this.props.userToken;var
      countryData = _this.state.countryData;
      var data = {
        staff_info: {
          phone: '+' + countryData + phone.replace(/\D/g, ''),
          description: description } };



      _this.props.editUserProfile({ userData: data, userToken: userToken });
    }, _this.

    handleClick = function (evt) {
      _this.props.handleSubmit(_this.formSubmitHandler)(evt);
    }, _this.

    renderPhoneNumber = function (_ref2) {var input = _ref2.input,_ref2$meta = _ref2.meta,error = _ref2$meta.error,touched = _ref2$meta.touched;return (
        _react2.default.createElement('div', { className: styles.phoneNumber },
          _react2.default.createElement(_reactIntlTelInput2.default, {
            autoPlaceholder: false,
            nationalMode: false,
            containerClassName: (0, _classnames2.default)('intl-tel-input'),
            inputClassName: 'form-control phone-input',
            fieldName: 'phone_number',
            value: input.value,
            preferredCountries: _constants.PREFERRED_COUNTRIES,
            onPhoneNumberChange: function onPhoneNumberChange(_, value) {
              input.onChange(value);
            },
            onSelectFlag: _this.onSelectFlag,
            useMobileFullscreenDropdown: false,
            separateDialCode: true }),

          error && touched &&
          _react2.default.createElement('span', { className: styles.required },
            _this.props.translate('errorFieldMessages', 'phone-number'))));}, _temp), _possibleConstructorReturn(_this, _ret);}EditUserStaff.prototype.





  render = function render() {var _props =
    this.props,translate = _props.translate,fields = _props.fields,locale = _props.locale,userData = _props.userData;

    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        _react2.default.createElement('h1', { className: styles.title }, translate('userStaff', 'realtorPage')),
        _react2.default.createElement('form', { noValidate: 'noValidate' },
          _react2.default.createElement('div', { className: styles.fieldWrapper },
            _react2.default.createElement('p', { className: styles.fieldTitle }, translate('userStaff', 'phoneNumber')),
            _react2.default.createElement(_reduxForm.Field, {
              name: 'phone',
              required: true,
              translate: translate,
              component: this.renderPhoneNumber,
              validate: this.validatePhoneNumber })),


          _react2.default.createElement('div', { className: styles.fieldWrapper },
            _react2.default.createElement('p', { className: styles.fieldTitle }, translate('userStaff', 'description')),
            _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
              translate: translate,
              classNameTabs: 'project-form',
              className: 'form-control',
              name: 'description',
              locale: locale,
              fields: fields.description,
              maxLength: '500',
              placeholderInput: translate('addNewProject'),
              isOptionalLangsDisabled: !(0, _lodash.get)(this.props.fields, 'description') })),


          _react2.default.createElement('button', {
              onClick: this.handleClick,
              className: styles.submit,
              disabled: userData.loading },

            translate('userStaff', 'submit')))));




  };return EditUserStaff;}(_react.Component);


EditUserStaff.propTypes = {
  handleSubmit: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  fields: _propTypes2.default.object,
  userData: _propTypes2.default.object,
  userToken: _propTypes2.default.string,
  editUserProfile: _propTypes2.default.func,
  translate: _propTypes2.default.func.isRequired };


var mapStateToProps = function mapStateToProps(store) {return {
    isRtl: (0, _checkRtlLanguage2.default)(store.lang.locale),
    locale: store.lang.locale,
    translate: (0, _reduxPagan.getLang)(store.lang, 'static'),
    userToken: (0, _lodash.get)(store, 'userAuthentication.data.access_token'),
    userData: store.userAuthentication,
    fields: {
      description: selector(store, 'description') },

    initialValues: store.userAuthentication.data ?
    {
      phone: (0, _lodash.get)(store, 'userAuthentication.data.staff_info.phone') || (0, _lodash.get)(store, 'userAuthentication.data.phone_number'),
      description: (0, _lodash.get)(store, 'userAuthentication.data.staff_info.description') } :

    null };};



var mapDispatchToProps = {
  editUserProfile: _userAuthentication.editUserProfile };exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps),
(0, _reduxForm.reduxForm)({
  form: 'editUserStaff',
  enableReinitialize: true }))(

EditUserStaff);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EditUserStaff/EditUserStaff.js
// module id = 2928
// module chunks = 0